import styled from 'styled-components';
import { spacing, zBanners } from '~/styled';

export const AcceptCookiesContainerDiv = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: ${() => zBanners};
  background: var(--background);
  padding: $tinySpacing;
  text-align: center;
  vertical-align: middle;
  border: 1px solid var(--ui-gray300);

  .ListButton {
    margin-left: ${() => spacing.standard};
  }
`;
